import { FC, FormEventHandler, PropsWithChildren } from "react";
import styled from "styled-components";

interface Props {
  title: string;
  headerLeftChild?: JSX.Element;
  headerRightChild?: JSX.Element;
  handleSubmit: FormEventHandler;
}

const StyleWrapper = styled.div`
  max-height: calc(100vh - 56px - 60px);
  overflow: scroll;
`;

const SearchScafold: FC<PropsWithChildren<Props>> = (props): JSX.Element => {
  const { children, title, headerLeftChild, headerRightChild, handleSubmit } =
    props;

  return (
    <form onSubmit={handleSubmit}>
      <div className="relative bg-white min-h-screen grid grid-rows-[auto_1fr_60px]">
        <header className="flex items-center justify-between border-b border-gray-100 h-[56px] px-12">
          <div className="flex items-center space-x-8">
            <button type="submit" className="text-sm">
              戻る
            </button>
            {headerLeftChild}
          </div>
          <h1 className="font-bold">{title}</h1>
          <div className="flex items-center space-x-8">{headerRightChild}</div>
        </header>
        <StyleWrapper>{children}</StyleWrapper>
        <button
          type="submit"
          className="fixed inset-x-0 bottom-0 w-full h-[60px] bg-black text-white font-bold"
        >
          決定する
        </button>
      </div>
    </form>
  );
};
export default SearchScafold;
